module.exports = __webpack_public_path__ + "img/7_95.393a74c2.png";